<template>
  <div class="px-2 mt-2">
    <!-- <header-slot>
      <template v-slot:content-right>
        <div class="mr-2">
          <b-button
            v-if="currentTab == 'pending'"
            v-b-tooltip.hover.right="$t('Register Discount')"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success"
            @click="openModalDiscount"
          >
            <div class="d-flex justify-content-between">
              <span> {{ $t("CREATE") }} </span>
            </div>
          </b-button>
        </div>
      </template>
    </header-slot> -->
    <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        :link-classes="['sub-tab-nav', 'px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
      <!-- exact -->
      <!-- :active="isActiveTab(index)" -->
      <!-- exact-active-class="sub-tab-nav" -->
    </b-nav>
    <b-card no-body class="border-top-info border-3 border-table-radius px-0">
      <router-view ref="routerViewTab" :key="routeName" />
    </b-card>
  </div>
</template>


<script>
/* SERVICES */
import Ripple from "vue-ripple-directive";

export default {
  components: {},
  directives: {
    Ripple,
  },
  data() {
    return {
      sidebarEmployee: false,
      filters: false,
    };
  },
  created() {},
  computed: {
    tabs() {
      return this.$route.matched[2].meta.tabs;
    },
    currentTab() {
      return this.$route.meta.tab;
    },
    routeName() {
      return this.$route.matched[3].name;
    },
  },
  methods: {
    openModalDiscount() {
      this.$refs.routerViewTab.openModalDiscount();
    },

    isActiveTab(tabIndex) {
      const tabName = this.tabs[tabIndex].name;

      return this.$route.matched.some((r) => r.name === tabName);
    },
    refreshTable() {
      this.$refs["routerViewTab"].refreshTable();
    },
  },
};
</script>
    
    
    